import { render, staticRenderFns } from "./StatusDialogOrderReview.vue?vue&type=template&id=869ca8c8"
import script from "./StatusDialogOrderReview.vue?vue&type=script&lang=js"
export * from "./StatusDialogOrderReview.vue?vue&type=script&lang=js"
import style0 from "./StatusDialogOrderReview.vue?vue&type=style&index=0&id=869ca8c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports